import { Turnstile } from "@marsidev/react-turnstile";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  onVerify?: (token: string) => void;
  onError?: () => void;
};

type Status = "ready" | "failed" | "expired";

export function TurnstileChallenge({ onVerify, onError }: Props) {
  const { t } = useTranslation();
  const [status, setStatus] = useState<Status>("ready");
  const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY;

  if (!siteKey) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="rounded-md border border-ember/30 bg-ember/5 px-3 py-2 text-sm text-ember"
      >
        {t("turnstile.missing_key")}
      </div>
    );
  }

  return (
    <div className="rounded-md border border-ember/30 bg-ember/5 px-3 py-3">
      <Turnstile
        siteKey={siteKey}
        onSuccess={(token) => {
          setStatus("ready");
          onVerify?.(token);
        }}
        onError={() => {
          setStatus("failed");
          onError?.();
        }}
        onExpire={() => setStatus("expired")}
        options={{ theme: "light" }}
      />
      {status !== "ready" && (
        <p role="alert" className="mt-2 text-sm text-ember">
          {status === "failed" ? t("turnstile.error") : t("turnstile.expired")}
        </p>
      )}
    </div>
  );
}
